function consultaResumenValoracion(shopSnipet, idProductoSnipet, idProducto) {
  (async () => {
    const formData = new FormData();
    formData.append('shop', shopSnipet);
    formData.append('idProducto', idProductoSnipet); //SKU
    const plainFormData = Object.fromEntries(formData.entries());
    const formDataJsonString = JSON.stringify(plainFormData);
    const fetchOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: formDataJsonString,
    };

    const response = await fetch('/apps/upango_gestor_opiniones/opiniones/obtener-resumen-valoracion/', fetchOptions);
    if (response.ok) {
      const body = await response.json();
      const resumen = body.data.respuesta;

      // Redondear la valoración media a un valor entero
      const valoracionMediaRedondeada = Math.round(resumen.valoracionMedia);

      // Generar los spans de estrellas
      const estrellas = generarEstrellas(valoracionMediaRedondeada);

      // Crear un span para el número de opiniones
      const numeroOpinionesSpan = document.createElement('span');
      numeroOpinionesSpan.textContent = `(${resumen.numeroOpiniones})`;

      // Limpiar el contenido actual del span
      const resumenValoracionContainer = document.getElementById(`resumen-valoracion-${idProducto}`);
      resumenValoracionContainer.innerHTML = '';

      // Agregar las estrellas al DOM dentro del span
      estrellas.forEach((estrella) => {
        resumenValoracionContainer.appendChild(estrella);
      });

      resumenValoracionContainer.appendChild(numeroOpinionesSpan);
      resumenValoracionContainer.parentElement.classList.remove('hidden');
    }
  })();
}

// Función para generar estrellas llenas y vacías como elementos <span>
function generarEstrellas(valoracion) {
  const estrellaLlena = document.createElement('span');
  estrellaLlena.innerHTML =
    '<svg class="icon-star" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none"  width="10" height="11"><use href="#icon-star-filled"></use></svg>';
  estrellaLlena.classList.add('star-filled');

  const estrellaVacia = document.createElement('span');
  estrellaVacia.innerHTML =
    '<svg class="icon-star" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none"  width="10" height="11"><use href="#icon-star-empty"></use></svg>';
  estrellaVacia.classList.add('star-empty');

  const estrellas = [];
  for (let i = 0; i < valoracion; i++) {
    estrellas.push(estrellaLlena.cloneNode(true));
  }
  for (let i = valoracion; i < 5; i++) {
    estrellas.push(estrellaVacia.cloneNode(true));
  }

  return estrellas;
}
